import React, { Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Actions
import actions from '../../actions/pages';

// layout
import Header from './header/Header';
import Footer from './footer/Footer';
import Newsletter from './newsletter/Newsletter';
import Modal from '../layouts/modal/Modal';
import GalleryWrapper from './GalleryWrapper';

// pages
import Page from '../pages/Page';
import Activity from '../singles/activity/Activity';
import Artwork from '../singles/artwork/Artwork';
import NotFound from '../pages/NotFound';
import UiKit from '../uiKit/UiKit';

// styles
import './styles.scss';

class PrimaryLayout extends Component {
  constructor(props, { initialRender, customStore }) {
    super(props);
    const { getPagesList } = props;
    if (initialRender) {
      getPagesList(customStore);
    }
  }

  componentDidMount() {
    const { getPagesList, pagesList } = this.props;
    if (Object.keys(pagesList).length === 0) {
      getPagesList();
    }
  }

  render() {
    const {
      modalIsVisible,
      pagesList,
      lang,
    } = this.props;
    const { t, initialRender } = this.context;
    return (
      <div className={classNames('primary-layout', { 'primary-layout--modal-open': modalIsVisible })}>
        <Header />
        <main className={`lang--${lang}`}>
          <Switch onChange={() => window && window.scrollTo(0, 0)}>
            <Redirect from="/" to="/fr" exact />
            <Route
              path={`/${lang}/${t('routes.uiKit')}`}
              component={UiKit}
            />
            {pagesList.length > 0 && pagesList
              .filter((page) => page.status === 'publish')
              .map(page =>
                <Route
                  path={`/${page.lang}${page.path}`}
                  render={() => <Page {...page} />}
                  exact
                  key={`route_page_${page.slug}`}
                />,
            )}
            {pagesList.length > 0 && pagesList
              .filter((page) => page.status !== 'publish')
              .map(page =>
                <Route
                  path={`/${page.lang}/preview/${page.id}`}
                  render={() => <Page preview {...page} />}
                  exact
                  key={`route_page_${page.slug}`}
                />,
              )}
            <Route
              path={`/${lang}/${t('routes.artwork')}/:slug`}
              render={() => <Artwork />}
              exact
            />
            <Route
              path={`/${lang}/${t('routes.activity')}/:slug`}
              render={() => <Activity />}
              exact
            />
            <Route
              path={`/${lang}/preview/${t('routes.artwork')}/:slug`}
              render={() => <Artwork preview />}
              exact
            />
            <Route
              path={`/${lang}/preview/${t('routes.activity')}/:slug`}
              render={() => <Activity preview />}
              exact
            />
            <Route
              path="/"
              component={NotFound}
            />
          </Switch>
          <Newsletter />
        </main>
        <Footer />
        { window && document && !initialRender && <GalleryWrapper /> }
        {modalIsVisible && <Modal />}
      </div>
    );
  }
}

PrimaryLayout.propTypes = {
  location: PropTypes.object.isRequired,
  modalIsVisible: PropTypes.bool.isRequired,
  pagesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  getPagesList: PropTypes.func.isRequired,
  lang: PropTypes.string,
};

PrimaryLayout.defaultProps = {
  lang: 'fr',
};

PrimaryLayout.contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
};


function mapStateToProps(state) {
  return {
    modalIsVisible: state.modal.isVisible,
    pagesList: state.pages.pagesList,
    lang: state.i18nState.lang,
  };
}

export default withRouter(connect(mapStateToProps, actions)(PrimaryLayout));



// WEBPACK FOOTER //
// ./src/app/components/layouts/PrimaryLayout.js